import { useEffect, useState } from 'react';
import { PHONE } from '../theme/tokens';

export function useMaxWidth(px) {
  const query = `(max-width: ${px}px)`;
  const [match, setMatch] = useState(() => window.matchMedia?.(query).matches || false);
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return undefined;
    setMatch(mq.matches);
    const on = (e) => setMatch(e.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, [query]);
  return match;
}

export const usePhone = () => useMaxWidth(PHONE);
